import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Typography, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import MyCropsIcon from "../../assets/Icon/MyCropsIcon.png";
import CustomCard from "../../components/Famer/GenericCard";
import ConfirmationPopup from "../../components/Popup/GenericPopup";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../components/Alert";

export default function Crops() {
  const [crops, setCrops] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [selectedCropId, setSelectedCropId] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    api
      .get(`/farmer/crops/`)
      .then((result) => {
        setCrops(result.data);
        setLoading(false);
      })
      .catch((err) => {
        alert("Error - " + err.response.data.non_field_errors[0]);
        setLoading(false);
      });
  };
  const handleAddCrops = () => {
    window.location.href = "/farmer/crops/create";
  };
  const handleView = (cropId) => {
    navigate(`/farmer/crop/${cropId}`);
  };
  const handleEditClick = (cropId) => {
    navigate(`/farmer/crops/create/?cropId=${cropId}`);
  };
  const handleDelete = (id) => {
    setSelectedCropId(id);
    setDeleteConfirmationOpen(true);
  };
  const handleConfirmDelete = () => {
    api
      .delete(`/farmer/crops/${selectedCropId}/`)
      .then((response) => {
        console.log("Crop deleted successfully", response);
        showAlert("success", "Crop deleted Successfully");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error deleting crop:", error);
        showAlert("error", "Some issue on deleting the crop");
      });
  };

  const getRenderValues = (crop) => {
    if (crop.farm_type === "CROP") {
      return {
        [t("Type")]: "Crop",
        [t("Land")]: crop.farmland.farm_name,
        [t("Crop Type")]: crop.commodity?.name,
        [t(crop.is_ratoon ? "Start Date" : "Sowing Date")]: crop.sowing_date,
        [t("Seed Type")]: crop.seed_type,
        [t("Seed Source")]: crop.seed_source,
        [t(
          crop.sowing_source === "SEED"
            ? "Seed Quantity (kg)"
            : "Number of Saplings"
        )]:
          crop.sowing_source === "SEED"
            ? crop.seed_quantity
            : crop.sapling_quantity,
        [t("Is EBC Contest")]: crop.is_ebc_contest ? t("Yes") : t("No"),
        [t("Is EBC Applied")]: crop.ebc_quantity > 0 ? t("Yes") : t("No"),
        [t("EBC Quantity")]: crop.ebc_quantity > 0 ? crop.ebc_quantity : "-",
      };
    } else {
      return {
        [t("Type")]: "Plantation",
        [t("Land")]: crop.farmland.farm_name,
        [t("Crop Type")]: crop.commodity?.name,
        [t("Nursery Name")]: crop.nursery_name,
        [t("Nursery Location")]: crop.nursery_location,
        [t("Plantation Method")]: crop.plantation_method,
        [t("Pit Size")]: crop.pit_size,
        [t("Plant Count")]: crop.plant_count,
        [t("Sowing Date")]: crop.sowing_date,
      };
    }
  };

  return (
    <>
      <Helmet>
        <title>My Crops - Farmapp</title>
      </Helmet>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <CustomButton onClick={handleAddCrops}>
          {t("Add Sowing Details")}
        </CustomButton>
        <Container
          maxWidth="xs"
          style={{
            height: crops.length === 0 ? "58vh" : "94vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            // alignItems: "center", // Center items horizontally
          }}
        >
          {crops.length !== 0 && (
            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontSize: "30px",
                fontWeight: 700,
                marginTop: "10px",
              }}
            >
              {t("My Crops")}
            </Typography>
          )}
          <div
            style={{
              overflowY: "auto",
              maxHeight: "calc(115vh - 300px)",
              textAlign: "center",
              height: "700px",
              margin: "auto",
            }}
          >
            {crops.map((crop) => (
              <CustomCard
                key={crop.id}
                id={crop.id}
                t={t}
                data={getRenderValues(crop)}
                file={crop.sowing_file}
                handlePrimaryButton={handleView}
                handleEditClick={() => handleEditClick(crop.id)}
                handleDelete={() => handleDelete(crop.id)}
              />
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {crops.length === 0 && (
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={MyCropsIcon}
                  alt="My Crops Icon"
                  style={{
                    width: "127px",
                    height: "127px",
                    marginBottom: "10px",
                  }}
                />
              </div>
            )}
            {crops.length === 0 && (
              <Typography
                variant="subtitle1"
                sx={{ mb: 2, textAlign: "center" }}
              >
                {t("Your Crops will be shown here once you add them.")}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>
      <ConfirmationPopup
        open={deleteConfirmationOpen}
        handleClose={() => setDeleteConfirmationOpen(false)}
        handleConfirm={handleConfirmDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this crop?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </>
  );
}
